import React, { useEffect, useState } from 'react';
import './EventsPageTable.css'
import { supabase } from '../../supabase';

const PaymentsPageTable = () => {
     const [payment, setPayment] = useState([]);

     useEffect(()=>{
             const getPayment = async () => {
                 const res = await supabase.from('Payments').select(`id,created_at,amount,method,status,Users:user_id ( user_Name )`)
                 setPayment(res.data)
                 console.log(res)
             }
     
             getPayment();
         } , [])

    return ( 
        <div className='EventsPageTable'>
            <p className='TableName'>All Payments</p>

            <table>
                <tr className='TopRow'>
                    <th>
                        Booking ID
                    </th>
                    <th>
                        User
                    </th>
                    <th>
                        Amount
                    </th>
                    <th>
                        Method
                    </th>
                    <th>
                        Date
                    </th>
                    <th>
                        Status
                    </th>
                </tr>
                {
                    payment.map((item)=>{
                        return <tr>
                            <td>
                                {item.id}
                            </td>
                            <td>
                                {item.Users?.user_Name}
                            </td>
                            <td>
                                {item.amount}
                            </td>
                            <td>
                                {item.method}
                            </td>
                            <td>
                                {item.created_at}
                            </td>
                            <td>
                                <p className={item.status}>
                                    {item.status}
                                </p>
                            </td>
                        </tr>
                    })
                }
            </table>
        </div>
     );
}
 
export default PaymentsPageTable;